import {useEffect} from "react";
import {saveLastCompanyId} from "../utils/localStorageUtils";
import {useCompany} from "./companiesHooks";
/**
 * Hook automatically persist last companyId in localStorage
 * Only stores if company fetching succeeded. In case of invalid id or permission denied error,
 * last company id will not be persisted
 */
export const useCompanyIdPersist = () => {
    const companyState = useCompany();
    useEffect(() => {
        if (companyState.isSuccess && companyState.data) {
            saveLastCompanyId(companyState.data.id);
        }
    }, [companyState]);
};
